import { GlobalStateType } from 'Lib/reduxType';
import { CACHE_STRATEGY_LRU, createDenormalizedSelector } from 'Lib/reduxUtils';

import { archivedMatchEntity } from 'Store/entities/archivedMatches.schema';
import { DenormalizedMatch } from 'Store/match/types';

import { ARCHIVED_MATCHES_ENTITY_KEY, MESSAGES_ENTITY_KEY, PROFILE_ENTITY_KEY } from './entityKeys';
import { createEntitiesTypeSelector } from './selectors';
import { getId } from './utils';

export const selectEntitiesForArchivedMatches = createEntitiesTypeSelector([
  ARCHIVED_MATCHES_ENTITY_KEY,
  PROFILE_ENTITY_KEY,
  MESSAGES_ENTITY_KEY,
]);

/**
 * Gets a denormalized match entity by ID
 *
 * @param  {GlobalState} state - top-level state
 * @param  {string} id - entity ID
 * @return {Match} denormalized entity
 */

type GetArchivedMatchById = (state: GlobalStateType, matchId?: string) => DenormalizedMatch;

export const getArchivedMatchById: GetArchivedMatchById = createDenormalizedSelector(
  getId,
  selectEntitiesForArchivedMatches,
  archivedMatchEntity,
  200, // 2 pages
  CACHE_STRATEGY_LRU
);
